<!--//线下实名认证-->
<template>
	<div id="box">
		<div id="container">
			<myhead></myhead>
			<main>
				<div class="left_bg">
				</div>
				<div class="right_log">
					<div class="title">线下实名认证</div>
					<!-- <div class="desc">
						<p class="all">可使用嗖嗖人力全部功能</p>
					</div> -->
					<p class="message">因部分业务功能只能向认证后的企业用户开放，为了不影响您的正常使用，<span>请填写您的销售顾问的联系方式、上传营业执照及法人身份证正反面，</span>我们会与您的销售顾问沟通后,尽快为您进行企业认证。</p>
					<div class="form">
						<el-form ref="form" :model="data" class="demo-form-inline">
							<el-form-item prop="name" :rules="{required: true, message: '请填写公司名称', trigger: 'blur'}">
								<el-input v-model.trim="data.name" placeholder="公司名称"></el-input>
							</el-form-item>
							<el-form-item prop="salesperson" :rules="{required: true, message: '请填写销售顾问姓名', trigger: 'blur'}">
								<el-input v-model.trim="data.salesperson" placeholder="销售顾问姓名"></el-input>
							</el-form-item>
							<el-form-item prop="salespersonMobile" :rules="{required: true, message: '请填写销售顾问电话', trigger: 'blur'}">
								<el-input v-model.trim="data.salespersonMobile" placeholder="销售顾问电话"></el-input>
							</el-form-item>
						</el-form>
					</div>
					<div class="updatePicture_section">
						<el-upload class="upload-demo" drag :limit='1' ref="my-upload1"  multiple
							:action='uploadUrl'
							:data='uploadData1'
							:before-upload='beforeUpload'
							:on-success='uploadSuccess'
							:on-change='uploadChange'
							:show-file-list='false'
							:with-credentials='true'
							>
							<div v-if="file1==true">
								<i class="el-icon-upload"></i>
								<div class="el-upload__text">
									点击或拖拽上传
									<div class="el-upload__text1">pdf、jpg、png格式</div>
									<div class="el-upload__text1">小于20M</div>
									<div>营业执照</div>
								</div>
							</div>
							<div v-if="file1 == false">
								<div class="license_img">
									<img :src="img1" alt="" >
								</div>
								<div class="license_name">
									<div>营业执照.jpg</div>
									<img src="../../../assets/img/delete.png" alt="" @click.stop="clearFiles(1)">
								</div>
							</div>
						</el-upload>
						<el-upload
							class="upload-demo" drag :limit="1" ref="my-upload2"  multiple
							:action='uploadUrl'
							:data='uploadData2'
							:before-upload='beforeUpload'
							:on-success='uploadSuccess'
							:on-change='uploadChange'
							:show-file-list='false'
							:with-credentials='true'
							>
							<div v-if="file2">
								<i class="el-icon-upload"></i>
								<div class="el-upload__text">
									点击或拖拽上传
									<div class="el-upload__text1">pdf、jpg、png格式</div>
									<div class="el-upload__text1">小于20M</div>
										<div>身份证正面</div>
								</div>
							</div>
							<div v-if="!file2">
								<div class="license_img">
									<img :src="img2" alt="" >
								</div>
								<div class="license_name">
									<div>身份证正面.jpg</div>
									<img src="../../../assets/img/delete.png" alt="" @click.stop="clearFiles(2)">
								</div>
							</div>
						</el-upload>
						<el-upload
							class="upload-demo" drag :limit="1" ref="my-upload3" multiple
							:action='uploadUrl'
							:data='uploadData3'
							:before-upload='beforeUpload'
							:on-success='uploadSuccess'
							:on-change='uploadChange'
							:show-file-list='false'
							:with-credentials='true'
							>
							<div v-if="file3">
								<i class="el-icon-upload"></i>
								<div class="el-upload__text">
									点击或拖拽上传
									<div class="el-upload__text1">pdf、jpg、png格式</div>
									<div class="el-upload__text1">小于20M</div>
									<div>身份证反面</div>
								</div>
							</div>
							<div v-if="!file3">
								<div class="license_img">
									<img :src="img3" alt="" >
								</div>
								<div class="license_name">
									<div>身份证反面.jpg</div>
									<img src="../../../assets/img/delete.png" alt=""  @click.stop="clearFiles(3)">
								</div>
							</div>
						</el-upload>
					</div>
					<div class="footerBtn">
						<button class="btn" type="button"  @click="$router.go(-1)">返回上一步</button>
						<button class="btn subbtn" @click='onsubmit'>下一步</button>
					</div>
				</div>
			</main>
			<myfoot></myfoot>
		</div>
	</div>
</template>

<script>
	
	export default {
		name: 'RealName',
	
		data() {
			return {
				id: '',
				companyName:'',
				data: {
					id: this.$route.query.id,
				    name: this.$route.query.name,
					salesperson: "",
					salespersonMobile: "",
				},
				file1: true,
				file2: true,
				file3: true,
				img1: '',
				img2: '',
				img3: '',
				uploadUrl: this.$axios.defaults.baseURL + '/companyContract/uploadfile',
				uploadData1: {
					id: this.$route.query.id,
					fileType: 1
				},
				uploadData2: {
					id: this.$route.query.id,
					fileType: 2
				},
				uploadData3: {
					id: this.$route.query.id,
					fileType: 3
				},
				filePath: {
					file1: '',
					file2: '',
					file3: ''
				}
			}
		},
		mounted() {
			this.companyId = this.$route.query.companyId;
			this.companyName = this.$route.query.companyName;
			this.data.companyName = this.companyName;
		},
		methods: {
			clearFiles(num){
				if(num == 1){
					this.file1 = true;		   
					this.img1 = "";
			    	this.$refs['my-upload1'].clearFiles();
				}
				if(num == 2){
				    this.file2 = true;		   
					this.img2 = "";
			    	this.$refs['my-upload2'].clearFiles();
				}
				if(num == 3){
					this.file3 = true;		   
					this.img3 = "";
			    	this.$refs['my-upload3'].clearFiles();
				}
				

			},
			beforeUpload(file){

			},
			uploadSuccess(res, file, fileList){
				if (res.status === 1) {
					if (res.data.fileType === 1) {
						this.file1 = false
						this.img1 = res.data.fileUrl
						this.filePath.file1 = res.data.fileName
					} else if (res.data.fileType === 2) {
						this.file2 = false
						this.img2 = res.data.fileUrl
						this.filePath.file2 = res.data.fileName
					} else if (res.data.fileType === 3) {
						this.file3 = false
						this.img3 = res.data.fileUrl
						this.filePath.file3 = res.data.fileName
					}
				}
			},
			uploadChange(file){
			},
		
			onsubmit() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						if (this.filePath.file1 != '' && this.filePath.file2 != '' && this.filePath.file3 != '') {
							this.data.certificateFile = this.filePath.file1 + ',' + this.filePath.file2 + ',' + this.filePath.file3
							this.$axios.post('/companyContract/launchOfflineAuthz', this.data).then(res => {
								if (res.data.status == 1) {
									this.$confirm('后续，您可在嗖嗖人力个人中心【企业设置】相关界面中提 交或查看您的企业身份认证状态。', '提示', {
										confirmButtonText: '我知道了',
										showCancelButton: false,
										iconClass: "el-icon-primary"
									}).then(() => {
										this.$router.push({
											path: '/main/system/system/company'
										})
									});
								} else {

					
									this.$message.error(res.data.message)
								}
							})
						} else {
							this.$message.error("请上传企业资料")
						}
					}
				});
			}
		}
	}
</script>

<style scoped lang="less">
	#app {
		position: relative;
	}

	#box {
		width: 100%;
		min-width: 1184px;
		background-color: #292b52;
		position: absolute;
		top: 0;
		bottom: 0;
		overflow: auto;

		#container {
			width: 1184px;
			margin: 0 auto;

			main {
				width: 100%;
				height: 560px;
				background-color: #fff;
				border-radius: 6px;
				display: flex;
				justify-content: space-evenly;

				/*overflow: hidden;*/
				.left_bg {
					width: 450px;
					height: 400px;
					background-image: url(../../../assets/img/1_10-14.png);
					margin: 5% 2px;
					background-repeat: no-repeat;

				}

				.right_log {
					width: 414px;
					height: 560px;
					margin-top: 50px;

					.title {
						margin-bottom: 10px;
					}

					.desc {
						display: flex;
						align-items: center;
						color: #0bb27a;
						font-size: 14px;
						margin: 10px 0;
					}

					.desc:after {
						content: '';
						width: 100px;
						height: 1px;
						background-color: #a8a8b3;
						margin-left: 20px;
					}

					.desc:before {
						content: '';
						width: 120px;
						height: 1px;
						background-color: #a8a8b3;
						margin-right: 20px;
					}

					.message {
						font-size: 12px;
						color: #555;
						margin-bottom: 10px;

						span {
							color: #555;
							font-weight: bold;
						}
					}

					.message1 {
						font-size: 12px;
						color: #555;
						margin-bottom: 10px;
					}

					.form {
						margin-bottom: 20px;
					}

					.entry {
						margin: 10px 0;

					}

					.footerBtn {
						width: 100%;
						display: flex;
						justify-content: space-around;
						margin-top: 20px;

						.btn {
							width: 100%;
						}

						.btn subbtn {
							width: 100%;
							
						}
					}

					.title {
						font-size: 30px;
						text-align: center;
						color: #000000;
						font-weight: bold;
						background-color: #fff;
						// margin-top: 57px;
					}
				}
			}
		}
	}

	@media (min-height:720px) {
		#container {
			width: 1184px !important;
			height: 720px;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto !important;
		}
	}

	.form /deep/ .el-form-item {
		margin-bottom: 10px;
	}
	.updatePicture_section {
		display: flex;
	}
	.updatePicture_section .upload-demo {
		margin-right: 5px;
	}
	.updatePicture_section /deep/ .el-upload-dragger{
		width:150px;
		height:150px;
	}
	.updatePicture_section /deep/ .el-icon-upload{
		    font-size: 45px;
		    margin: 14px 0 0;
	}
	.el-upload__text1{
		color:#8a8a9a;
		font-size:12px;
	}
	.license_img{
		width:150px;
		height:110px;
		overflow: hidden;
		img{
			// height:110px;
			width: 148px;
    	height: 147px;
		}
	}
	.license_name{
		div{
			display: inline-block;
			width: 93px;
		}
		img{
			width:25px;
			vertical-align:middle;
			padding: 6px 10px;
		}
	}
</style>
